export const TRANSACTIONS = {
  addNode: 'add node',
  addPorts: 'add ports',
  align: 'align',
  deletePorts: 'delete ports',
  deleteTab: 'delete tab',
  syncNode: 'sync node',
  syncPull: 'sync pull',
};
